import { render, staticRenderFns } from "./TrademarkSearchTypeForm.vue?vue&type=template&id=815fb2c4&"
import script from "./TrademarkSearchTypeForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkSearchTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkSearchTypeForm.vue?vue&type=style&index=0&id=815fb2c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports